<template>
  <header>
    <img src="@grasp-gg/web-ab-inbev/assets/logo.svg" />
    <div class="title">
      <h1>
        <a @click="goHome"> Taxonomy Builder </a>
      </h1>
      <span
        >Powered by
        <a
          href="https://grasp.gg"
          target="_blank"
          >Grasp</a
        >
      </span>
    </div>
  </header>

  <RouterView />
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';

const route = useRoute();

const goHome = () => {
  document.location = `/${route.query.country ? `?country=${route.query.country}` : ''}`;
};
</script>

<style lang="sass" scoped>
header
  padding: 0 30px
  display: flex
  background: var(--primary-color)
  align-items: center
  justify-content: center
  color: #fff

  img
    width: 125px
    height: 56px

  .title
    display: flex
    flex-direction: column

    h1
      margin: 0
      font-size: 30px
      font-weight: bold
      line-height: inherit

      &:hover
        text-decoration: underline

    a
      cursor: pointer

    span
      margin-top: -5px
      text-align: right
      font-size: 12px
      font-weight: 100
      font-style: italic

      a
        color: #fff

@media (min-width: 500px)
  header
    height: 100px

    img
      position: absolute
      top: 20px
      left: 40px

@media (max-width: 500px)
  header
    flex-direction: column

    img
      margin-top: 20px

    h1
      margin: 30px 0px
      line-height: inherit
</style>
